<div class="modal-wrapper">
  <div class="modal-header">
    <h2>Upload Providers</h2>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="modal-body">
    <app-provider-upload [organizationId]="data.organizationId"></app-provider-upload>
  </div>
</div>